import UserManagementRoutes from "./UserManagement/UserManagement";
import MasterRoutes from "./Master/MasterRoutes";
import WarehouseRoutes from "./Warehouse/WarehouseRoutes";
import InventoryRoutes from "./Inventory/InventoryRoutes";
import OrderRoutes from "./Order/Order";

const CombinedRoutes: any = [
  ...UserManagementRoutes,
  ...MasterRoutes,
  ...WarehouseRoutes,
  ...InventoryRoutes,
  ...OrderRoutes,
];

export default CombinedRoutes;
